<div class="container-fluid container-background">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
            <div class="outer">
                <div class="middle">
                    <div class="login-form-container">
                        <div class="login-header-title" *ngIf="!isMigrating && !isIncomplete">
                            <i class="zmdi zmdi-lock zdmi-fw"></i> Your account has been suspended.
                        </div>
                        <div class="login-header-title" *ngIf="isMigrating">
                            <i class="zmdi zmdi-lock zdmi-fw"></i>&nbsp;Whoops! It looks like you can't log in just yet. 
                            Hang tight – we're currently in the process of migrating your account. 
                            We will send you an email as soon as the migration is complete. 
                            Thanks for your patience!
                        </div>
                        <div class="login-header-title" *ngIf="isIncomplete">
                            <i class="zmdi zmdi-lock zdmi-fw"></i> Your account is being processed. Please check your email for further instructions.
                        </div>
                        <span (click)="openContactSupport()" class="syncblue showhand"
                            id="acct-status-contact-support">Contact Sync customer service</span> for further
                        assistance.
                    </div>
                </div> <!-- middle -->
            </div> <!-- outer -->
        </div>
        <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
        </div>
    </div>
</div>